var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('popup', {
    attrs: {
      "opened": _vm.dataToShow
    },
    on: {
      "close": _vm.close
    }
  }, [_c('div', [_c('div', {
    staticClass: "my-5 mx-5 lg:my-15 lg:mx-40 2xl:my-20 2xl:mx-32 text-center"
  }, [_c('h3', {
    staticClass: "mb-10"
  }, [_vm._v("\n        Supprimer la catégorie « " + _vm._s(_vm.category) + " »\n      ")]), _vm._v(" "), _c('p', {
    staticClass: "text-indigo-600 text-lg"
  }, [_vm._v("\n        Êtes-vous sûr de vouloir supprimer la catégorie « " + _vm._s(_vm.category) + " » ?\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "mt-5 text-red-500 text-sm text-center"
  }, [_vm._v("\n        " + _vm._s(((_vm.errors || [])['forbidden'] || [])[0]) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "flex justify-center space-x-5 mt-10"
  }, [_c('action-button', {
    attrs: {
      "border-color": "border-pink-600",
      "text-color": "text-pink-600",
      "bg-color": "bg-pink-100",
      "bg-color-square": "bg-pink-600",
      "icon-color": "text-white",
      "libelle": "Annuler",
      "uppercase": true
    },
    on: {
      "clickAction": function ($event) {
        return _vm.close();
      }
    }
  }), _vm._v(" "), _c('action-button', {
    attrs: {
      "border-color": "border-transparent",
      "text-color": "text-white",
      "bg-color": _vm.saving ? 'bg-gray-600' : 'bg-pink-600',
      "bg-color-square": _vm.saving ? 'bg-gray-600' : 'bg-pink-600',
      "libelle": "Supprimer",
      "uppercase": true,
      "type-shadow": _vm.saving ? 'shadow-gray' : 'shadow-pink'
    },
    on: {
      "clickAction": function ($event) {
        return _vm.deleteCategory(_vm.category);
      }
    }
  })], 1)])])]);

}
var staticRenderFns = []

export { render, staticRenderFns }